import React from 'react';
import { DownloadIcon, InfinityIcon, XCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ScarcityBar } from './ScarcityBar';
const MOCKUP = 'https://cdn.magicpatterns.com/uploads/9pChPfFSFEEmVaVCmYZHTg/MOCKUP_PRINCIPAL_AROMAS.png';
const chips = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: XCircleIcon,
  label: 'Sin suscripciones'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía 30 días'
}];
export function Hero({
  ctaId
}: {
  ctaId: string;
}) {
  return <header className="relative w-full overflow-hidden bg-[#2a2438] pb-10 pt-8 text-white" data-id="element-124" data-mp="sb1cvtp1w785">
      {/* soft glow */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-72 w-72 -translate-x-1/2 rounded-full bg-[#7c6aa8] opacity-30 blur-3xl" data-id="element-125" data-mp="nczt16jsw3vm" />

      <div className="relative mx-auto flex max-w-md flex-col items-center px-5 text-center" data-id="element-126" data-mp="3d2tpxe128sgn">
        <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/20 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.2em] text-[#d8c19a]" data-id="element-127" data-mp="3814a7l2w7qm8">
          Biblioteca de Rituales Aromáticos™
        </span>

        <h1 className="font-serif-display text-4xl font-bold leading-[1.05] sm:text-5xl" data-id="element-128" data-mp="39auqrc9b5kwp">
          El sistema que convierte productos aromáticos comunes en
          <span className="mt-1 block text-[#c9b8ea]" data-id="element-129" data-mp="3ebirwqr93i4n">experiencias premium.</span>
        </h1>

        <p className="mt-4 text-sm leading-relaxed text-white/75 sm:text-base" data-id="element-130" data-mp="30gq5r9guv3p3">
          Convierte tus velas, jabones, difusores, sprays o productos aromáticos en una marca que deja de competir por precio y comienza a vender por valor, aplicando un sistema probado de rituales, percepción premium y branding sensorial.
        </p>

        <div className="relative mt-7 w-full" data-id="element-131" data-mp="2hjf6hov84a9n">
          <img src={MOCKUP} alt="Biblioteca de Rituales Aromáticos: 6 tomos premium y herramientas de implementación" className="animate-float-soft mx-auto w-full max-w-sm drop-shadow-2xl" data-id="element-132" data-mp="2hkgl23bg7ew4" />
        </div>

        <div className="mt-6 grid w-full grid-cols-2 gap-2.5" data-id="element-133" data-mp="nbl42pi3sock">
          {chips.map(c => <div key={c.label} className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-3 py-2.5 text-left" data-id="element-134" data-mp="ic89fikzqczf">
              <c.icon className="w-4 h-4 shrink-0 text-[#c9b8ea]" data-id="element-135" data-mp="db2ede3uydmq" />
              <span className="text-xs font-medium leading-tight" data-id="element-136" data-mp="1azkvlrn8ois7">{c.label}</span>
            </div>)}
        </div>

        <div className="mt-7 w-full rounded-2xl bg-white/95 p-4 text-[#2a2438] shadow-xl" data-id="element-137" data-mp="15zq35jntfl51">
          <ScarcityBar data-id="element-138" data-mp="110wp9q4m9s4c" />
          <div className="my-4 h-px w-full bg-[#e4dbcc]" data-id="element-139" data-mp="x14o3yhjyo90" />
          <div className="flex items-center justify-center gap-2 text-sm" data-id="element-140" data-mp="x0l50eg61tte">
            <span className="text-[#8a8296] line-through" data-id="element-141" data-mp="3lt74sotvtnt7">$162 USD</span>
            <span className="font-serif-display text-3xl font-bold text-[#3b3350]" data-id="element-142" data-mp="3hrllolqr8dak">$12.99 USD</span>
          </div>
          <p className="mb-4 text-center text-[11px] text-[#8a8296]" data-id="element-143" data-mp="1x9ukuaytndnf">
            Pago único · El cambio de moneda es automático a tu país
          </p>
          <CTAButton id={ctaId} label="Sí, quiero mi Biblioteca" data-id="element-144" data-mp="218tntq0zt0c8" />
        </div>
      </div>
    </header>;
}